<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/pallet_inspections">Pallet Inspections</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" v-if="status">New Pallet Inspection</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Pallet Inspection</li>
                </ol>
                <h4 class="main-title mb-0">Pallet Inspection</h4>
            </div>
            <div>
                <router-link to="/pallet_inspections" type="button" class="btn btn-danger me-2"><i class="ri-close-line fs-18 lh-1"></i> Back</router-link>
                <button type="button" v-if="status" class="btn btn-primary me-2" @click="addPalletInspection()"><i class="ri-save-line fs-18 lh-1"></i> Submit</button>
                <button type="button" v-else class="btn btn-primary me-2" @click="updatePalletInspection()"><i class="ri-save-line fs-18 lh-1"></i> Update</button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-2">
                <form>
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New Pallet Inspection</h6>
                            <h6 class="card-title" v-else>Edit Pallet Inspection</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-3">
                                    <label class="form-label">Receipt No.</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Receipt No." class="form-control" disabled="disabled" :class="{ 'is-invalid': errors?.receipt_no }" v-model="inspection.receipt_no" />
                                    <span v-if="errors?.receipt_no"><small class="text-danger">{{ errors?.receipt_no[0] }}</small></span>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Receipt Date</label><span class="text-danger"> *</span>
                                    <input
                                        type="date"
                                        placeholder="Receipt Date Time"
                                        class="form-control"
                                        :class="{ 'is-invalid': errors?.receipt_date_time }"
                                        :max="today"
                                        :value="convertDateFormat(inspection.receipt_date_time)"
                                        v-model="inspection.receipt_date_time"
                                    />
                                    <span v-if="errors?.receipt_date_time"><small class="text-danger">{{ errors?.receipt_date_time[0] }}</small></span>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Supplier</label><span class="text-danger"> *</span>
                                    <search
                                        :class="{ 'is-invalid': errors?.supplier_id }"
                                        :customClass="{ 'is-invalid': errors?.supplier_id }"
                                        :initialize="inspection.supplier_id"
                                        id="supplier_id"
                                        label="supplier_name"
                                        placeholder="Select Supplier"
                                        :data=" suppliers"
                                        @input=" supplier1 => inspection.supplier_id = supplier1"
                                    >
                                    </search>
                                    <span v-if="errors?.supplier_id" class="invalid-feedback">{{ errors?.supplier_id[0] }}</span>
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Wagon No.</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Wagon No." class="form-control" :class="{ 'is-invalid': errors?.wagon_no }" v-model="inspection.wagon_no" @input="handleUpperCase" />
                                    <span v-if="errors?.wagon_no" class="invalid-feedback">{{ errors?.wagon_no[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea rows="2" type="text" placeholder="Note" class="form-control" :class="{ 'is-invalid': errors?.note }" v-model="inspection.note"></textarea>
                                    <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12 mb-2">
                <form>
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New Inspection Lots</h6>
                            <h6 class="card-title" v-else>Edit Inspection Lots</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <table class="table table-responsive table-responsive-sm table-sm text-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Lot No.</th>
                                                <th>Pallet Size</th>
                                                <th>Number Of Pallet</th>
                                                <th>Weight</th>
                                                <th>Moisture</th>
                                                <th class="text-center">Actions</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <input type="text" class="form-control" placeholder="Lot No." :class="{ 'is-invalid': errors.lot_no }" v-model="lot.lot_no" />
                                                    <span v-if="errors.lot_no" class="invalid-feedback">{{ errors.lot_no[0] }}</span>
                                                </td>
                                                <td>
                                                    <!-- <input type="text" class="form-control" placeholder="Pallet Size" :class="{ 'is-invalid': errors.pallet_size }" v-model="lot.pallet_size" />
                                            <span v-if="errors.pallet_size" class="invalid-feedback">{{ errors.pallet_size[0] }}</span> -->
                                                    <search
                                                        :class="{ 'is-invalid': errors.pallet_size_id }"
                                                        :customClass="{ 'is-invalid': errors.pallet_size_id }"
                                                        :initialize="lot.pallet_size_id"
                                                        id="pallet_size_id"
                                                        label="pallet_size_name"
                                                        placeholder="Select Pallet Size"
                                                        :data=" pallet_sizes"
                                                        @input=" pallet_size => lot.pallet_size_id = pallet_size"
                                                        @selectSearch="getPallet(lot.pallet_size_id)"
                                                    >
                                                    </search>
                                                    <span v-if="errors.pallet_size_id" class="invalid-feedback">{{ errors.pallet_size_id[0] }}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        class="form-control"
                                                        placeholder="Number Of Pallet"
                                                        :min="getMinNumberOfPalletForInput()"
                                                        :class="{ 'is-invalid': errors.number_of_pallet }"
                                                        v-model.number="lot.number_of_pallet"
                                                        @input="onNumberOfPalletChange(lot)"
                                                    />
                                                    <span v-if="errors.number_of_pallet" class="invalid-feedback">{{ errors.number_of_pallet[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" placeholder="Weight" :class="{ 'is-invalid': errors.weight }" v-model="lot.weight" />
                                                    <span v-if="errors.weight" class="invalid-feedback">{{ errors.weight[0] }}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="Moisture (avg)"
                                                        disabled
                                                        :value="getLotMoistureDisplay(lot)"
                                                    />
                                                    <small v-if="!hasCompletePalletDetails(lot)" class="text-muted">Add pallet details</small>
                                                    <span v-if="errors.inspection_lot_pallets" class="invalid-feedback d-block">{{ errors.inspection_lot_pallets[0] }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-info mx-1"
                                                        title="Pallet details"
                                                        :disabled="!canOpenPalletModal(lot)"
                                                        @click.prevent="openPalletModal(lot, null)"
                                                    >
                                                        <i class="ri-stack-line fs-18 lh-1"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-secondary mx-1"
                                                        title="Upload images"
                                                        @click.prevent="openLotImagesModal(lot, null)"
                                                    >
                                                        <i class="ri-image-add-line fs-18 lh-1"></i>
                                                    </button>
                                                    <button v-if="lot_status" class="btn btn-outline-success mx-1" @click.prevent="addRow()"><i class="ri-add-line fs-18 lh-1"></i></button>
                                                    <button v-else class="btn btn-outline-success mx-1" @click.prevent="updateRow()"><i class="ri-save-line fs-18 lh-1"></i></button>
                                                    <button class="btn btn-outline-danger mx-1" @click.prevent="discardNewRow()"><i class="ri-close-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="lot, index in inspection.inspection_lots" :key="index">
                                                <!-- <td class="text-center">{{ lot?.storage_id }}</td>s -->

                                                <td>{{ lot?.lot_no }}</td>
                                                <td>{{ lot?.pallet_size?.pallet_size_name }}</td>
                                                <td>{{ lot?.number_of_pallet }}</td>
                                                <td>{{ lot?.weight }}</td>
                                                <td>{{ getLotMoistureDisplay(lot) }}</td>
                                                <td class="text-center">
                                                    <button type="button" class="btn btn-outline-primary mx-1" @click.prevent="editLot(lot,index)"><i class="ri-pencil-line fs-18 lh-1"></i></button>
                                                    <button type="button" class="btn btn-outline-danger" @click.prevent="deleteLot(lot,index)"><i class="ri-delete-bin-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal fade" tabindex="-1" id="inspectionLotPalletModal" ref="inspectionLotPalletModal">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Pallet details — Lot {{ activePalletLot?.lot_no || '—' }}
                        <small class="text-muted d-block fw-normal">
                            Pallet size: {{ getLotPalletSizeName(activePalletLot) }} · {{ palletModalRows.length }} pallet(s)
                        </small>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style="width: 60px">#</th>
                                    <th>Moisture <span class="text-danger">*</span></th>
                                    <th>Remarks</th>
                                    <th v-if="!status" style="width: 80px" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, rowIndex) in palletModalRows"
                                    :key="row.inspection_lot_pallet_id || `new-${rowIndex}`"
                                    :class="{ 'table-secondary': row.pendingDelete }"
                                >
                                    <td class="text-center align-middle">
                                        {{ rowIndex + 1 }}
                                        <small v-if="row.pendingDelete" class="d-block text-danger">To delete</small>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="Moisture"
                                            :class="{ 'is-invalid': row.errors?.moisture }"
                                            :disabled="row.pendingDelete"
                                            v-model="row.moisture"
                                        />
                                        <span v-if="row.errors?.moisture" class="invalid-feedback d-block">{{ row.errors.moisture[0] }}</span>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="Remarks"
                                            :disabled="row.pendingDelete"
                                            v-model="row.remarks"
                                        />
                                    </td>
                                    <td v-if="!status" class="text-center align-middle">
                                        <button
                                            v-if="canUndoPalletModalRow(row)"
                                            type="button"
                                            class="btn btn-outline-secondary btn-sm"
                                            title="Undo delete"
                                            @click="undoPalletModalRow(row)"
                                        >
                                            Undo
                                        </button>
                                        <button
                                            v-else-if="canDeletePalletModalRow(row)"
                                            type="button"
                                            class="btn btn-outline-danger btn-sm"
                                            title="Delete pallet"
                                            @click="requestDeletePalletModalRow(row, rowIndex)"
                                        >
                                            <i class="ri-delete-bin-line"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer flex-wrap justify-content-between">                   
                    <div class="ms-auto">                  
                        <button type="button" class="btn btn-primary" @click="submitPalletModal">
                            <i class="ri-save-line fs-18 lh-1"></i> Save pallets
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" tabindex="-1" id="inspectionLotImagesModal" ref="inspectionLotImagesModal">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Lot images — {{ activeLotImagesLot?.lot_no || '—' }}
                        <small class="text-muted d-block fw-normal">
                            Pallet size: {{ getLotPalletSizeName(activeLotImagesLot) }}
                        </small>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <input
                            ref="lotImagesFileInput"
                            type="file"
                            class="form-control"
                            accept="image/*"
                            multiple
                            @change="onLotImagesSelected"
                        />
                        <small class="text-muted">Select one or more images. Files are renamed before upload to S3.</small>
                    </div>
                    <div v-if="!lotImagesModalList.length" class="text-muted text-center py-3">
                        No images yet for this lot.
                    </div>
                    <div v-else class="row g-2">
                        <div
                            v-for="(item, imgIndex) in lotImagesModalList"
                            :key="item.key || item.inspection_lot_attachment_id || `pending-${imgIndex}`"
                            class="col-md-4 col-sm-6"
                        >
                            <div class="card h-100">
                                <div class="card-body text-center p-2">
                                    <img
                                        class="img-fluid rounded mb-2"
                                        style="max-height: 120px; object-fit: cover"
                                        :src="getLotImageSrc(item)"
                                        alt="Lot image"
                                    />
                                    <div class="small text-muted text-truncate" :title="item.attachment_name || item.original_name">
                                        {{ item.attachment_name || item.original_name || 'New image' }}
                                    </div>
                                </div>
                                <div class="card-footer d-flex flex-wrap gap-1 justify-content-center p-2">
                                    <a
                                        v-if="item.inspection_lot_attachment_id"
                                        :href="$store.getters.apiUrl + 'downloadImage?filename=' + item.attachment_name"
                                        target="_blank"
                                        class="btn btn-sm btn-primary"
                                    >
                                        <i class="ri-download-line"></i> Download
                                    </a>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="removeLotImage(item, imgIndex)"
                                    >
                                        <i class="ri-delete-bin-line"></i> Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button
                        v-if="activeLotImagesLot && hasUnsavedLotAttachments(activeLotImagesLot)"
                        type="button"
                        class="btn btn-primary"
                        @click="saveLotImagesModal"
                    >
                        <i class="ri-upload-2-line"></i> Upload
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" tabindex="-1" id="palletDeleteConfirmModal" ref="palletDeleteConfirmModal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Delete pallet</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="mb-0">Are you sure you want to delete this pallet?</p>
                    <p class="text-muted small mb-0 mt-2">
                        It will be removed from the database when you click <strong>Update</strong> on the inspection.
                        You can click <strong>Undo</strong> in the table before updating.
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="confirmDeletePalletModalRow">
                        <i class="ri-delete-bin-line"></i> Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Search from "@/components/Search.vue";
    import Pagination from "@/components/Pagination.vue";
    import moment from "moment";
    export default {
        components: {
            Pagination,
            Search,
        },
        data() {
            return {
                inspection: {
                    inspection_id: "",
                    receipt_no: "",
                    receipt_date_time: "",
                    supplier_id: "",
                    wagon_no: "",
                    note: "",
                    inspection_lots: [],
                    deleted_inspection_lots: [],
                },
                lot: {
                    inspection_lot_id: "",
                    lot_no: "",
                    pallet_size_id: "",
                    pallet_size: {
                        pallet_size_name: "",
                    },
                    number_of_pallet: "",
                    weight: "",
                    moisture: "",
                    inspection_lot_pallets: [],
                    deleted_inspection_lot_pallet_ids: [],
                    inspection_lot_attachments: [],
                    min_number_of_pallet: null,
                },
                deleted_lots_row: [],
                lot_status: true,
                status: true,
                suppliers: [],
                pallet_sizes: [],
                errors: [],
                today: "",
                activePalletLot: null,
                activePalletLotIndex: null,
                palletModalRows: [],
                palletModalInstance: null,
                palletDeleteConfirmModalInstance: null,
                pendingDeletePalletRow: null,
                pendingDeletePalletRowIndex: null,
                activeLotImagesLot: null,
                activeLotImagesLotIndex: null,
                lotImagesModalList: [],
                lotImagesModalInstance: null,
            };
        },
        mounted() {
            this.getSuppliers();
            this.inspection.receipt_date_time = moment().format("yyyy-MM-DD HH:mm:ss");
            this.today = moment().format("yyyy-MM-DD");
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name == "Inspection.Create") {
                    vm.generateReceiptNo();
                    // vm.generateTripNo();
                    // vm.addInspectionLot();
                } else {
                    vm.status = false;
                    vm.inspection.inspection_id = to.params.inspection_id;
                    let uri = { uri: "getInspection", data: vm.inspection };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.inspection = response.data.data;
                            vm.inspection.receipt_date_time = moment(vm.inspection.receipt_date_time).format("yyyy-MM-DD HH:mm:ss");
                            vm.inspection.deleted_inspection_lots = [];
                            vm.inspection.inspection_lots = (vm.inspection.inspection_lots || []).map(
                                (lot, index) => ({
                                    ...lot,
                                    key: index,
                                    number_of_pallet: parseInt(lot.number_of_pallet, 10) || 0,
                                    inspection_lot_pallets: vm.normalizePalletList(
                                        lot.inspection_lot_pallets
                                    ),
                                    pallet_size: lot.pallet_size || { pallet_size_name: "" },
                                    weight: lot.weight ?? lot.pallet_size_parameter?.weight ?? "",
                                    moisture: lot.moisture ?? lot.pallet_size_parameter?.moisture ?? "",
                                    deleted_inspection_lot_pallet_ids: [],
                                    min_number_of_pallet:
                                        parseInt(lot.number_of_pallet, 10) || null,
                                    inspection_lot_attachments: lot.inspection_lot_attachments || [],
                                })
                            );
                            vm.enrichInspectionLotsPalletsFromApi();
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },

        methods: {
            generateReceiptNo() {
                let vm = this;
                let uri = {
                    uri: "generateReceiptNo",
                };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.inspection.receipt_no = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getPallet(pallet_size_id) {
                const pallet = this.pallet_sizes.find(
                    (ele) => ele.pallet_size_id == pallet_size_id
                );
                if (pallet) {
                    this.lot.pallet_size.pallet_size_name = pallet.pallet_size_name;
                }
            },
            getSuppliers() {
                let vm = this;
                let uri = { uri: "getSuppliers" };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.suppliers = response.data.data;
                        vm.getPalletSizes();
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getPalletSizes() {
                let vm = this;
                let uri = { uri: "getPalletSizes" };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.pallet_sizes = response.data.data;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            handleUpperCase() {
                this.inspection.wagon_no = this.inspection.wagon_no?.toUpperCase();
            },

            validateErrors() {
                if (!this.lot.lot_no) {
                    this.errors.lot_no = ["Lot No field cannot be empty"];
                } else {
                    delete this.errors.lot_no;
                }
                if (!this.lot.pallet_size_id) {
                    this.errors.pallet_size_id = ["Pallet Size Id field cannot be empty"];
                } else {
                    delete this.errors.pallet_size_id;
                }
                const minPallet = this.getLotMinNumberOfPallet(this.lot);
                const palletCountInput = parseInt(this.lot.number_of_pallet, 10);
                if (!this.lot.number_of_pallet) {
                    this.errors.number_of_pallet = ["Number of pallet field cannot be empty"];
                } else if (minPallet && palletCountInput < minPallet) {
                    this.errors.number_of_pallet = [
                        `Number of pallet cannot be less than ${minPallet}`,
                    ];
                } else {
                    delete this.errors.number_of_pallet;
                }
                if (!this.lot.weight) {
                    this.errors.weight = ["Weight field cannot be empty"];
                } else {
                    delete this.errors.weight;
                }
                const palletCount = parseInt(this.lot.number_of_pallet, 10) || 0;
                if (!this.hasCompletePalletDetails(this.lot)) {
                    this.errors.inspection_lot_pallets = [
                        `Enter moisture for all ${palletCount} pallet(s) using Pallet details`,
                    ];
                } else {
                    delete this.errors.inspection_lot_pallets;
                    this.lot.moisture = this.calculateAverageMoisture(
                        this.lot.inspection_lot_pallets,
                        palletCount
                    );
                }
                return Object.keys(this.errors).length > 0;
            },

            getLotIndex(lot) {
                if (!lot || !this.inspection.inspection_lots?.length) {
                    return -1;
                }
                if (lot.key !== undefined && lot.key !== null) {
                    const byKey = this.inspection.inspection_lots.findIndex(
                        (item) => item.key === lot.key
                    );
                    if (byKey !== -1) {
                        return byKey;
                    }
                }
                if (lot.inspection_lot_id) {
                    return this.inspection.inspection_lots.findIndex(
                        (item) => item.inspection_lot_id === lot.inspection_lot_id
                    );
                }
                return -1;
            },

            syncActiveLotToInspection() {
                if (this.lot_status) {
                    return;
                }
                const lotIndex = this.getLotIndex(this.lot);
                if (lotIndex === -1) {
                    return;
                }
                const count = parseInt(this.lot.number_of_pallet, 10) || 0;
                const existing = this.inspection.inspection_lots[lotIndex];
                this.inspection.inspection_lots[lotIndex] = {
                    ...existing,
                    inspection_lot_id: this.lot.inspection_lot_id,
                    lot_no: String(this.lot.lot_no || "").toUpperCase(),
                    pallet_size_id: this.lot.pallet_size_id,
                    pallet_size: this.lot.pallet_size,
                    number_of_pallet: count,
                    weight: this.lot.weight,
                    moisture: this.lot.moisture,
                    key: existing.key ?? lotIndex,
                    inspection_lot_pallets: this.syncPalletsToCount(
                        this.lot.inspection_lot_pallets,
                        count,
                        this.lot
                    ),
                    deleted_inspection_lot_pallet_ids: [
                        ...(this.lot.deleted_inspection_lot_pallet_ids || []),
                    ],
                    inspection_lot_attachments: [...(this.lot.inspection_lot_attachments || [])],
                    min_number_of_pallet: this.lot.min_number_of_pallet ?? null,
                };
            },

            syncMinNumberOfPalletFromCount(lot, count) {
                if (this.status || !lot) {
                    return;
                }
                const parsed = parseInt(count, 10);
                if (!parsed || parsed < 1) {
                    return;
                }
                lot.min_number_of_pallet = parsed;
                const lotIndex = this.getLotIndex(lot);
                if (lotIndex !== -1 && this.inspection.inspection_lots[lotIndex]) {
                    this.inspection.inspection_lots[lotIndex].min_number_of_pallet = parsed;
                }
                if (
                    !this.lot_status &&
                    (this.lot === lot || this.getLotIndex(this.lot) === lotIndex)
                ) {
                    this.lot.min_number_of_pallet = parsed;
                    if (this.errors.number_of_pallet?.[0]?.includes("cannot be less than")) {
                        delete this.errors.number_of_pallet;
                    }
                }
            },

            addRow() {
                let vm = this
                if (!vm.validateErrors()) {
                    const newKey = vm.inspection.inspection_lots.length;
                    vm.inspection.inspection_lots.push({
                        key: newKey,
                        lot_id: "",
                        lot_no: String(vm.lot.lot_no).toUpperCase(),
                        pallet_size_id: vm.lot.pallet_size_id,
                        pallet_size: {
                            pallet_size_name: vm.lot.pallet_size.pallet_size_name,
                        },
                        number_of_pallet: parseInt(vm.lot.number_of_pallet, 10) || 0,
                        weight: vm.lot.weight,
                        moisture: vm.calculateAverageMoisture(
                            vm.lot.inspection_lot_pallets,
                            parseInt(vm.lot.number_of_pallet, 10)
                        ),
                        inspection_lot_pallets: [...(vm.lot.inspection_lot_pallets || [])],
                        deleted_inspection_lot_pallet_ids: [],
                        inspection_lot_attachments: [...(vm.lot.inspection_lot_attachments || [])],
                    });
                    vm.discardNewRow();
                }
            },
            updateRow() {
                let vm = this;
                if (!vm.validateErrors()) {
                    vm.syncActiveLotToInspection();
                    vm.discardNewRow();
                }
            },

            discardNewRow() {
                let vm = this
                vm.lot.lot_no = ''
                vm.lot.pallet_size_id = ''
                vm.lot.pallet_size.pallet_size_name = ''
                vm.lot.number_of_pallet = ''
                vm.lot.weight = ''
                vm.lot.moisture = ''
                vm.lot.inspection_lot_pallets = []
                vm.lot.deleted_inspection_lot_pallet_ids = []
                vm.lot.inspection_lot_attachments = []
                vm.lot.min_number_of_pallet = null
                vm.lot_status = true
                vm.errors = {}
            },
            getLotMinNumberOfPallet(lot) {
                if (this.status || this.lot_status) {
                    return null;
                }
                const min = parseInt(lot?.min_number_of_pallet, 10);
                return min > 0 ? min : null;
            },
            getMinNumberOfPalletForInput() {
                return this.getLotMinNumberOfPallet(this.lot) || 1;
            },
            editLot(lot, key) {
                let vm = this;
                vm.lot.inspection_lot_id = lot.inspection_lot_id
                vm.lot.lot_no = lot.lot_no
                vm.lot.pallet_size_id = lot.pallet_size_id
                vm.lot.pallet_size.pallet_size_name = lot.pallet_size?.pallet_size_name || ""
                vm.lot.number_of_pallet = lot.number_of_pallet
                vm.lot.min_number_of_pallet =
                    parseInt(lot.min_number_of_pallet ?? lot.number_of_pallet, 10) || null
                vm.lot.weight = lot.weight
                vm.lot.moisture = lot.moisture
                vm.lot.inspection_lot_pallets = [...(lot.inspection_lot_pallets || [])]
                vm.lot.deleted_inspection_lot_pallet_ids = [
                    ...(lot.deleted_inspection_lot_pallet_ids || []),
                ]
                vm.lot.inspection_lot_attachments = [...(lot.inspection_lot_attachments || [])]
                vm.lot_status = false;
                vm.lot.key = key;
                vm.errors = [];
            },

            // deleteLot(lot, key) {
            //         let vm = this;
            //         vm.inspection.deleted_inspection_lots.push(lot), vm.inspection.inspection_lots.splice(key, 1);
            //         vm.discardNewRow();
            //     },

            deleteLot(lot, key) {
                let vm = this;
                if (confirm("Are you sure you want to delete")) {
                    const lotId = parseInt(lot?.inspection_lot_id, 10);
                    if (lotId) {
                        vm.deleted_lots_row.push(lotId);
                    }
                    vm.inspection.inspection_lots.splice(key, 1);
                    vm.discardNewRow();
                }
            },
            validateAllLotsPalletDetails() {
                const incomplete = (this.inspection.inspection_lots || []).find(
                    (lot) => !this.hasCompletePalletDetails(lot)
                );
                if (incomplete) {
                    this.$store.dispatch(
                        "error",
                        `Lot ${incomplete.lot_no || "—"}: enter moisture for all pallets via Pallet details.`
                    );
                    return false;
                }
                return true;
            },

            addPalletInspection() {
                let vm = this;
                if (!vm.inspection.inspection_lots?.length) {
                    vm.$store.dispatch("error", "Add at least one inspection lot before submitting.");
                    return;
                }
                (vm.inspection.inspection_lots || []).forEach((lot) =>
                    vm.hydrateLotPalletsForSubmit(lot)
                );
                if (!vm.validateAllLotsPalletDetails()) {
                    return;
                }
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addInspection", data: vm.inspection })
                    .then((response) => {
                        const savedInspection = response.data?.data;
                        if (savedInspection?.inspection_id) {
                            vm.inspection.inspection_id = savedInspection.inspection_id;
                            (savedInspection.inspection_lots || []).forEach((savedLot) => {
                                const localLot = (vm.inspection.inspection_lots || []).find(
                                    (l) =>
                                        String(l.lot_no).toUpperCase() ===
                                        String(savedLot.lot_no).toUpperCase()
                                );
                                if (localLot) {
                                    localLot.inspection_lot_id = savedLot.inspection_lot_id;
                                }
                            });
                        }
                        return vm.uploadAllPendingLotAttachments();
                    })
                    .then(() => {
                        loader.hide();
                        vm.$store.dispatch("success", "Inspection created successfully");
                        vm.$router.push("/pallet_inspections");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors || {};
                        vm.$store.dispatch("error", error.response?.data?.message || "Failed to create inspection");
                    });
            },
            prepareInspectionForUpdate() {
                this.syncActiveLotToInspection();

                (this.inspection.inspection_lots || []).forEach((lot) => {
                    lot.number_of_pallet = parseInt(lot.number_of_pallet, 10) || 0;
                    if (!Array.isArray(lot.deleted_inspection_lot_pallet_ids)) {
                        lot.deleted_inspection_lot_pallet_ids = [];
                    }
                });
            },

            updatePalletInspection() {
                let vm = this;
                vm.prepareInspectionForUpdate();
                (vm.inspection.inspection_lots || []).forEach((lot) => {
                    const count = parseInt(lot.number_of_pallet, 10) || 0;
                    if (count > 0) {
                        lot.number_of_pallet = count;
                        vm.hydrateLotPalletsForSubmit(lot);
                    }
                });
                if (!vm.validateAllLotsPalletDetails()) {
                    return;
                }
                vm.inspection.deleted_inspection_lots = [...new Set(vm.deleted_lots_row.filter((id) => !!id))];
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateInspection", data: vm.inspection })
                    .then((response) => vm.syncAllLotsPalletsToDatabase().then(() => response))
                    .then((response) => vm.uploadAllPendingLotAttachments().then(() => response))
                    .then((response) => {
                        loader.hide();
                        vm.deleted_lots_row = [];
                        vm.inspection.deleted_inspection_lots = [];
                        (vm.inspection.inspection_lots || []).forEach((lot) => {
                            lot.deleted_inspection_lot_pallet_ids = [];
                        });
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/pallet_inspections");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors;
                        vm.$store.dispatch("error", error.response?.data?.message || "Failed to update inspection");
                    });
            },

            syncAllLotsPalletsToDatabase() {
                const vm = this;
                const lots = (vm.inspection.inspection_lots || []).filter(
                    (lot) => lot.inspection_lot_id
                );
                if (!lots.length) {
                    return Promise.resolve();
                }

                const requests = lots
                    .map((lot) => {
                        const pallets = vm
                            .filterOutDeletedPallets(lot.inspection_lot_pallets, lot)
                            .map((row) => ({
                                inspection_lot_pallet_id: row.inspection_lot_pallet_id || undefined,
                                moisture: row.moisture,
                                remarks: row.remarks || null,
                            }));
                        if (!pallets.length) {
                            return null;
                        }
                        const palletCount = pallets.length;
                        return vm.$store.dispatch("post", {
                            uri: "bulkStoreInspectionLotPallets",
                            data: {
                                inspection_id: vm.inspection.inspection_id,
                                inspection_lot_id: lot.inspection_lot_id,
                                number_of_pallet: palletCount,
                                allow_delete: true,
                                inspection_lot_pallets: pallets,
                            },
                        });
                    })
                    .filter(Boolean);

                return requests.length ? Promise.all(requests) : Promise.resolve();
            },

            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("yyyy-MM-DD");
            },

            canOpenPalletModal(lot) {
                const count = parseInt(lot?.number_of_pallet, 10);
                return count > 0;
            },

            hasCompletePalletDetails(lot) {
                const count = parseInt(lot?.number_of_pallet, 10) || 0;
                const pallets = this.filterOutDeletedPallets(lot?.inspection_lot_pallets, lot);
                if (!count) {
                    return false;
                }
                if (pallets.length === count) {
                    return pallets.every((row) => row.moisture?.toString().trim());
                }
                return false;
            },

            hydrateLotPalletsForSubmit(lot) {
                const count = parseInt(lot?.number_of_pallet, 10) || 0;
                if (!count) {
                    return;
                }

                let pallets = this.syncPalletsToCount(
                    this.filterOutDeletedPallets(lot?.inspection_lot_pallets, lot),
                    count,
                    lot
                );

                const avgMoisture = lot?.moisture?.toString().trim();
                if (avgMoisture) {
                    const allEmpty = pallets.every((row) => !row.moisture?.toString().trim());
                    if (allEmpty) {
                        pallets = pallets.map((row) => ({
                            ...row,
                            moisture: avgMoisture,
                        }));
                    }
                }

                lot.inspection_lot_pallets = pallets;
            },

            enrichInspectionLotsPalletsFromApi() {
                const lots = (this.inspection.inspection_lots || []).filter((lot) => {
                    if (!lot.inspection_lot_id) {
                        return false;
                    }
                    const count = parseInt(lot.number_of_pallet, 10) || 0;
                    const pallets = this.filterOutDeletedPallets(lot.inspection_lot_pallets, lot);
                    return count > 0 && pallets.length !== count;
                });

                if (!lots.length) {
                    return Promise.resolve();
                }

                return Promise.all(
                    lots.map((lot) =>
                        this.$store
                            .dispatch("post", {
                                uri: "getInspectionLotPallets",
                                data: { inspection_lot_id: lot.inspection_lot_id },
                            })
                            .then((response) => {
                                const list = this.normalizePalletList(
                                    response.data?.data || response.data
                                );
                                if (list.length) {
                                    lot.inspection_lot_pallets = list;
                                    const count = parseInt(lot.number_of_pallet, 10) || 0;
                                    if (count && this.hasCompletePalletDetails(lot)) {
                                        lot.moisture = this.calculateAverageMoisture(
                                            lot.inspection_lot_pallets,
                                            count
                                        );
                                    }
                                }
                            })
                            .catch(() => {
                                /* keep existing lot data */
                            })
                    )
                );
            },

            calculateAverageMoisture(pallets, numberOfPallet) {
                const count = parseInt(numberOfPallet, 10) || 0;
                if (!count || !pallets?.length) {
                    return "";
                }
                const sum = pallets.reduce(
                    (total, row) => total + (parseFloat(row.moisture) || 0),
                    0
                );
                return (sum / count).toFixed(2);
            },

            getLotMoistureDisplay(lot) {
                if (lot?.moisture) {
                    return lot.moisture;
                }
                const count = parseInt(lot?.number_of_pallet, 10);
                if (this.hasCompletePalletDetails(lot)) {
                    return this.calculateAverageMoisture(lot.inspection_lot_pallets, count);
                }
                return "";
            },

            normalizePalletList(payload) {
                if (!payload) {
                    return [];
                }
                if (Array.isArray(payload)) {
                    return payload;
                }
                if (Array.isArray(payload.data)) {
                    return payload.data;
                }
                return [];
            },

            getDeletedPalletIds(lot) {
                return (lot?.deleted_inspection_lot_pallet_ids || []).map((id) => String(id));
            },

            filterOutDeletedPallets(pallets, lot) {
                const deletedIds = new Set(this.getDeletedPalletIds(lot));
                return this.normalizePalletList(pallets).filter((row) => {
                    if (!row.inspection_lot_pallet_id) {
                        return true;
                    }
                    return !deletedIds.has(String(row.inspection_lot_pallet_id));
                });
            },

            ensureLotDeletedPalletIds(lot, index) {
                if (
                    index !== null &&
                    index !== undefined &&
                    this.inspection.inspection_lots[index]
                ) {
                    if (!this.inspection.inspection_lots[index].deleted_inspection_lot_pallet_ids) {
                        this.inspection.inspection_lots[index].deleted_inspection_lot_pallet_ids = [];
                    }
                    lot.deleted_inspection_lot_pallet_ids =
                        this.inspection.inspection_lots[index].deleted_inspection_lot_pallet_ids;
                } else if (!lot.deleted_inspection_lot_pallet_ids) {
                    lot.deleted_inspection_lot_pallet_ids = [];
                }
            },

            syncPalletsToCount(pallets, count, lot = null) {
                const all = this.filterOutDeletedPallets(pallets, lot);
                const saved = all
                    .filter((row) => row.inspection_lot_pallet_id)
                    .sort(
                        (a, b) =>
                            Number(a.inspection_lot_pallet_id) -
                            Number(b.inspection_lot_pallet_id)
                    );
                const pending = all.filter((row) => !row.inspection_lot_pallet_id);
                const result = saved.map((row) => ({ ...row }));

                pending.forEach((row) => {
                    if (result.length < count) {
                        result.push({ ...row });
                    }
                });

                while (result.length < count) {
                    result.push({ moisture: "", remarks: null });
                }

                return result.slice(0, count);
            },

            onNumberOfPalletChange(lot) {
                let count = parseInt(lot.number_of_pallet, 10);

                if (Number.isNaN(count) || count < 1) {
                    return;
                }

                const minCount = this.getLotMinNumberOfPallet(lot);
                if (minCount && count < minCount) {
                    this.errors.number_of_pallet = [
                        `Number of pallet cannot be less than ${minCount}`,
                    ];
                    lot.number_of_pallet = minCount;
                    count = minCount;
                } else if (this.errors.number_of_pallet?.[0]?.includes("cannot be less than")) {
                    delete this.errors.number_of_pallet;
                }

                if (!this.status) {
                    lot.number_of_pallet = count;
                    lot.inspection_lot_pallets = this.syncPalletsToCount(
                        lot.inspection_lot_pallets,
                        count,
                        lot
                    );
                    const filled = (lot.inspection_lot_pallets || []).filter((row) =>
                        row.moisture?.toString().trim()
                    );
                    lot.moisture = this.calculateAverageMoisture(filled, count);
                    this.syncActiveLotToInspection();
                    return;
                }

                lot.inspection_lot_pallets = [];
                lot.moisture = "";
            },

            buildPalletModalRows(lot) {
                const count = parseInt(lot.number_of_pallet, 10) || 0;
                const all = this.filterOutDeletedPallets(lot.inspection_lot_pallets, lot);
                const saved = all
                    .filter((row) => row.inspection_lot_pallet_id)
                    .sort(
                        (a, b) =>
                            Number(a.inspection_lot_pallet_id) -
                            Number(b.inspection_lot_pallet_id)
                    );
                const pending = all.filter((row) => !row.inspection_lot_pallet_id);
                const rows = saved.map((row) => ({
                    inspection_lot_pallet_id: row.inspection_lot_pallet_id,
                    moisture: row.moisture ?? "",
                    remarks: row.remarks ?? "",
                    pendingDelete: false,
                    errors: {},
                }));

                pending.forEach((row) => {
                    if (rows.length < count) {
                        rows.push({
                            inspection_lot_pallet_id: null,
                            moisture: row.moisture ?? "",
                            remarks: row.remarks ?? "",
                            pendingDelete: false,
                            errors: {},
                        });
                    }
                });

                while (rows.length < count) {
                    rows.push({
                        inspection_lot_pallet_id: null,
                        moisture: "",
                        remarks: "",
                        pendingDelete: false,
                        errors: {},
                    });
                }

                return rows.slice(0, count);
            },

            getActivePalletModalRows() {
                return (this.palletModalRows || []).filter((row) => !row.pendingDelete);
            },

            canDeletePalletModalRow(row) {
                if (!this.activePalletLot || row?.pendingDelete) {
                    return false;
                }

                return this.getActivePalletModalRows().length > 1;
            },

            canUndoPalletModalRow(row) {
                return !!row?.pendingDelete;
            },

            syncModalRowsToLot(lot, index) {
                const activeRows = this.getActivePalletModalRows();
                const pallets = activeRows.map((item) => ({
                    inspection_lot_pallet_id: item.inspection_lot_pallet_id || null,
                    moisture: item.moisture,
                    remarks: item.remarks || null,
                }));
                const count = activeRows.length;

                this.syncMinNumberOfPalletFromCount(lot, count);
                lot.number_of_pallet = count;
                lot.inspection_lot_pallets = pallets;
                lot.moisture = this.calculateAverageMoisture(pallets, count);

                const lotIndex =
                    index !== null && index !== undefined ? index : this.getLotIndex(lot);
                if (lotIndex !== -1 && this.inspection.inspection_lots[lotIndex]) {
                    this.inspection.inspection_lots[lotIndex].number_of_pallet = count;
                    this.inspection.inspection_lots[lotIndex].inspection_lot_pallets = [...pallets];
                    this.inspection.inspection_lots[lotIndex].moisture = lot.moisture;
                    this.inspection.inspection_lots[lotIndex].deleted_inspection_lot_pallet_ids = [
                        ...(lot.deleted_inspection_lot_pallet_ids || []),
                    ];
                }
                if (this.lot_status === false && this.getLotIndex(this.lot) === lotIndex) {
                    this.lot.number_of_pallet = count;
                    this.lot.inspection_lot_pallets = [...pallets];
                    this.lot.moisture = lot.moisture;
                }
            },

            undoPalletModalRow(row) {
                const lot = this.activePalletLot;
                const index = this.activePalletLotIndex;

                row.pendingDelete = false;
                row.errors = {};

                if (row.inspection_lot_pallet_id && lot?.deleted_inspection_lot_pallet_ids) {
                    lot.deleted_inspection_lot_pallet_ids =
                        lot.deleted_inspection_lot_pallet_ids.filter(
                            (id) => String(id) !== String(row.inspection_lot_pallet_id)
                        );
                }

                this.syncModalRowsToLot(lot, index);
                this.$store.dispatch("success", "Delete cancelled. This pallet will be kept.");
            },

            applyLotPalletState(lot, index, pallets, numberOfPallet, moisture) {
                const count =
                    parseInt(numberOfPallet, 10) ||
                    parseInt(lot?.number_of_pallet, 10) ||
                    pallets.length;
                const synced = this.syncPalletsToCount(pallets, count, lot);

                this.syncMinNumberOfPalletFromCount(lot, count);
                lot.number_of_pallet = count;
                lot.inspection_lot_pallets = synced;
                lot.moisture = moisture ?? lot.moisture ?? "";

                const lotIndex =
                    index !== null && index !== undefined ? index : this.getLotIndex(lot);
                if (lotIndex !== -1 && this.inspection.inspection_lots[lotIndex]) {
                    this.inspection.inspection_lots[lotIndex].number_of_pallet = count;
                    this.inspection.inspection_lots[lotIndex].inspection_lot_pallets = synced;
                    this.inspection.inspection_lots[lotIndex].moisture = lot.moisture;
                    this.inspection.inspection_lots[lotIndex].deleted_inspection_lot_pallet_ids =
                        lot.deleted_inspection_lot_pallet_ids || [];
                }

                if (this.activePalletLot === lot || this.getLotIndex(this.lot) === lotIndex) {
                    this.lot.number_of_pallet = count;
                    this.lot.inspection_lot_pallets = [...synced];
                    this.lot.moisture = lot.moisture;
                }
            },

            getPalletDeleteConfirmModal() {
                const el = this.$refs.palletDeleteConfirmModal;
                if (!el || !window.bootstrap?.Modal) {
                    return null;
                }
                return window.bootstrap.Modal.getOrCreateInstance(el);
            },

            requestDeletePalletModalRow(row, rowIndex) {
                if (!this.canDeletePalletModalRow(row)) {
                    return;
                }
                this.pendingDeletePalletRow = row;
                this.pendingDeletePalletRowIndex = rowIndex;
                const modal = this.getPalletDeleteConfirmModal();
                if (modal) {
                    this.palletDeleteConfirmModalInstance = modal;
                    modal.show();
                }
            },

            confirmDeletePalletModalRow() {
                const row = this.pendingDeletePalletRow;
                const rowIndex = this.pendingDeletePalletRowIndex;
                if (row !== null && rowIndex !== null && rowIndex !== undefined) {
                    this.deletePalletModalRow(row, rowIndex);
                }
                if (this.palletDeleteConfirmModalInstance) {
                    this.palletDeleteConfirmModalInstance.hide();
                }
                this.pendingDeletePalletRow = null;
                this.pendingDeletePalletRowIndex = null;
            },

            deletePalletModalRow(row, rowIndex) {
                const lot = this.activePalletLot;
                const index = this.activePalletLotIndex;

                if (!this.canDeletePalletModalRow(row)) {
                    return;
                }

                this.ensureLotDeletedPalletIds(lot, index);

                row.pendingDelete = true;
                row.errors = {};

                if (row.inspection_lot_pallet_id) {
                    const palletId = row.inspection_lot_pallet_id;
                    if (!lot.deleted_inspection_lot_pallet_ids.includes(palletId)) {
                        lot.deleted_inspection_lot_pallet_ids.push(palletId);
                    }
                }

                this.syncModalRowsToLot(lot, index);

                this.$store.dispatch(
                    "success",
                    "Pallet marked for deletion. It will be removed from the database when you click Update on the inspection. Click Undo to cancel."
                );
            },

            openPalletModal(lot, index) {
                if (!this.lot_status && this.getLotIndex(this.lot) !== -1) {
                    this.syncActiveLotToInspection();
                    const lotIndex = this.getLotIndex(this.lot);
                    if (lotIndex !== -1) {
                        lot = this.inspection.inspection_lots[lotIndex];
                    }
                }

                const count = parseInt(lot.number_of_pallet, 10);
                if (!count || count < 1) {
                    this.$store.dispatch("error", "Enter a valid number of pallets first.");
                    return;
                }

                this.activePalletLot = lot;
                this.activePalletLotIndex =
                    index !== null && index !== undefined ? index : this.getLotIndex(lot);

                const showModal = () => {
                    this.palletModalRows = this.buildPalletModalRows(lot);
                    const el = this.$refs.inspectionLotPalletModal;
                    if (window.bootstrap?.Modal) {
                        this.palletModalInstance = window.bootstrap.Modal.getOrCreateInstance(el);
                        this.palletModalInstance.show();
                    }
                };

                if (this.inspection.inspection_id && lot.inspection_lot_id) {
                    const loader = this.$loading.show();
                    const targetIndex = this.activePalletLotIndex;
                    this.$store
                        .dispatch("post", {
                            uri: "getInspectionLotPallets",
                            data: { inspection_lot_id: lot.inspection_lot_id },
                        })
                        .then((response) => {
                            loader.hide();
                            const fromApi = this.filterOutDeletedPallets(
                                this.normalizePalletList(response.data),
                                lot
                            );
                            const pending = this.filterOutDeletedPallets(
                                lot.inspection_lot_pallets,
                                lot
                            ).filter((row) => !row.inspection_lot_pallet_id);
                            const merged = this.syncPalletsToCount(
                                [...fromApi, ...pending],
                                count,
                                lot
                            );
                            lot.inspection_lot_pallets = merged;
                            lot.number_of_pallet = count;
                            if (
                                targetIndex !== null &&
                                targetIndex !== undefined &&
                                targetIndex !== -1 &&
                                this.inspection.inspection_lots[targetIndex]
                            ) {
                                this.inspection.inspection_lots[targetIndex].inspection_lot_pallets =
                                    merged;
                                this.inspection.inspection_lots[targetIndex].number_of_pallet = count;
                                this.inspection.inspection_lots[targetIndex].deleted_inspection_lot_pallet_ids =
                                    lot.deleted_inspection_lot_pallet_ids || [];
                            }
                            showModal();
                        })
                        .catch((error) => {
                            loader.hide();
                            this.$store.dispatch(
                                "error",
                                error.response?.data?.message || "Failed to load pallet details"
                            );
                            showModal();
                        });
                    return;
                }

                showModal();
            },

            hidePalletModal() {
                if (this.palletModalInstance) {
                    this.palletModalInstance.hide();
                }
            },

            validatePalletModalRows() {
                let valid = true;
                this.getActivePalletModalRows().forEach((row) => {
                    row.errors = {};
                    if (!row.moisture?.toString().trim()) {
                        row.errors.moisture = ["Moisture is required"];
                        valid = false;
                    }
                });
                return valid;
            },

            submitPalletModal() {
                if (!this.validatePalletModalRows()) {
                    return;
                }

                const activeRows = this.getActivePalletModalRows();
                const pallets = activeRows.map((row) => ({
                    inspection_lot_pallet_id: row.inspection_lot_pallet_id || undefined,
                    moisture: row.moisture,
                    remarks: row.remarks || null,
                }));

                const lot = this.activePalletLot;
                const index =
                    this.activePalletLotIndex !== null &&
                    this.activePalletLotIndex !== undefined &&
                    this.activePalletLotIndex !== -1
                        ? this.activePalletLotIndex
                        : this.getLotIndex(lot);
                const palletCount = activeRows.length;
                const averageMoisture = this.calculateAverageMoisture(pallets, palletCount);

                const inspectionId = this.inspection.inspection_id;
                const inspectionLotId = lot?.inspection_lot_id;

                const savedPallets = this.normalizePalletList(
                    activeRows.map((row) => ({
                        inspection_lot_pallet_id: row.inspection_lot_pallet_id || null,
                        moisture: row.moisture,
                        remarks: row.remarks || null,
                    }))
                );
                this.applyLotPalletState(lot, index, savedPallets, palletCount, averageMoisture);
                this.syncActiveLotToInspection();
                this.hidePalletModal();

                if (inspectionId && inspectionLotId) {
                    this.$store.dispatch(
                        "success",
                        "Pallet details saved. Click Update on the inspection to save."
                    );
                } else {
                    this.$store.dispatch(
                        "success",
                        "Pallet details saved. Submit inspection to save."
                    );
                }
            },

            getLotImageSrc(item) {
                if (item?.attachment_path) {
                    return item.attachment_path;
                }
                if (item?.preview) {
                    return item.preview;
                }
                if (item?.attachment_name) {
                    return this.$store.getters.apiUrl + 'downloadImage?filename=' + item.attachment_name;
                }
                return '';
            },

            getLotPalletSizeName(lot) {
                if (!lot) {
                    return "—";
                }
                return (
                    lot.pallet_size?.pallet_size_name ||
                    this.pallet_sizes.find((p) => p.pallet_size_id == lot.pallet_size_id)
                        ?.pallet_size_name ||
                    "—"
                );
            },

            ensureLotAttachmentArrays(lot) {
                if (!lot.inspection_lot_attachments) {
                    lot.inspection_lot_attachments = [];
                }
            },

            isUnsavedLotAttachment(item) {
                return item && !item.inspection_lot_attachment_id && !!item.attachment;
            },

            getUnsavedLotAttachments(lot) {
                return (lot?.inspection_lot_attachments || []).filter((item) =>
                    this.isUnsavedLotAttachment(item)
                );
            },

            buildLotImagesModalList(lot) {
                this.ensureLotAttachmentArrays(lot);
                return (lot.inspection_lot_attachments || []).map((item, index) => ({
                    ...item,
                    key:
                        item.key ||
                        (item.inspection_lot_attachment_id
                            ? `saved-${item.inspection_lot_attachment_id}`
                            : `unsaved-${index}`),
                }));
            },

            hasUnsavedLotAttachments(lot) {
                return this.getUnsavedLotAttachments(lot).length > 0;
            },

            openLotImagesModal(lot, index) {
                if (!this.lot_status && this.getLotIndex(this.lot) !== -1) {
                    this.syncActiveLotToInspection();
                    const lotIndex = this.getLotIndex(this.lot);
                    if (lotIndex !== -1) {
                        lot = this.inspection.inspection_lots[lotIndex];
                    }
                }

                this.activeLotImagesLot = lot;
                this.activeLotImagesLotIndex =
                    index !== null && index !== undefined ? index : this.getLotIndex(lot);

                const showModal = () => {
                    this.lotImagesModalList = this.buildLotImagesModalList(lot);
                    const el = this.$refs.inspectionLotImagesModal;
                    if (window.bootstrap?.Modal) {
                        this.lotImagesModalInstance =
                            window.bootstrap.Modal.getOrCreateInstance(el);
                        this.lotImagesModalInstance.show();
                    }
                };

                if (lot.inspection_lot_id) {
                    const loader = this.$loading.show();
                    this.$store
                        .dispatch("post", {
                            uri: "getInspectionLotAttachments",
                            data: { inspection_lot_id: lot.inspection_lot_id },
                        })
                        .then((response) => {
                            loader.hide();
                            const list = response.data?.data || response.data || [];
                            const unsaved = this.getUnsavedLotAttachments(lot);
                            lot.inspection_lot_attachments = [
                                ...(Array.isArray(list) ? list : []),
                                ...unsaved,
                            ];
                            const targetIndex = this.activeLotImagesLotIndex;
                            if (
                                targetIndex !== null &&
                                targetIndex !== undefined &&
                                targetIndex !== -1 &&
                                this.inspection.inspection_lots[targetIndex]
                            ) {
                                this.inspection.inspection_lots[targetIndex].inspection_lot_attachments =
                                    lot.inspection_lot_attachments;
                            }
                            showModal();
                        })
                        .catch((error) => {
                            loader.hide();
                            this.$store.dispatch(
                                "error",
                                error.response?.data?.message || "Failed to load lot images"
                            );
                            showModal();
                        });
                    return;
                }

                showModal();
            },

            hideLotImagesModal() {
                if (this.lotImagesModalInstance) {
                    this.lotImagesModalInstance.hide();
                }
                if (this.$refs.lotImagesFileInput) {
                    this.$refs.lotImagesFileInput.value = "";
                }
            },

            onLotImagesSelected(event) {
                const lot = this.activeLotImagesLot;
                if (!lot) {
                    return;
                }
                this.ensureLotAttachmentArrays(lot);
                const files = Array.from(event.target.files || []);
                if (!files.length) {
                    return;
                }

                const readers = files.map(
                    (file) =>
                        new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                const dataUrl = e.target.result;
                                const typeMatch = String(dataUrl).match(/data:(.*?);/);
                                resolve({
                                    attachment: dataUrl,
                                    type: typeMatch ? typeMatch[1] : file.type || "image/jpeg",
                                    preview: dataUrl,
                                    original_name: file.name,
                                    key: `pending-${Date.now()}-${Math.random()}`,
                                });
                            };
                            reader.readAsDataURL(file);
                        })
                );

                Promise.all(readers).then((items) => {
                    lot.inspection_lot_attachments.push(...items);
                    this.lotImagesModalList = this.buildLotImagesModalList(lot);
                    this.syncLotAttachmentsToInspection(lot);
                    if (this.$refs.lotImagesFileInput) {
                        this.$refs.lotImagesFileInput.value = "";
                    }
                });
            },

            removeLotImage(item, imgIndex) {
                const lot = this.activeLotImagesLot;
                if (!lot) {
                    return;
                }

                if (item.inspection_lot_attachment_id) {
                    if (
                        !confirm("Delete this image from storage?")
                    ) {
                        return;
                    }
                    const loader = this.$loading.show();
                    this.$store
                        .dispatch("post", {
                            uri: "deleteInspectionLotAttachment",
                            data: {
                                inspection_lot_attachment_id: item.inspection_lot_attachment_id,
                            },
                        })
                        .then(() => {
                            loader.hide();
                            lot.inspection_lot_attachments = (
                                lot.inspection_lot_attachments || []
                            ).filter(
                                (a) =>
                                    a.inspection_lot_attachment_id !==
                                    item.inspection_lot_attachment_id
                            );
                            this.syncLotAttachmentsToInspection(lot);
                            this.lotImagesModalList = this.buildLotImagesModalList(lot);
                            this.$store.dispatch("success", "Image deleted");
                        })
                        .catch((error) => {
                            loader.hide();
                            this.$store.dispatch(
                                "error",
                                error.response?.data?.message || "Failed to delete image"
                            );
                        });
                    return;
                }

                lot.inspection_lot_attachments = (lot.inspection_lot_attachments || []).filter(
                    (p) => p.key !== item.key
                );
                this.syncLotAttachmentsToInspection(lot);
                this.lotImagesModalList = this.buildLotImagesModalList(lot);
            },

            syncLotAttachmentsToInspection(lot) {
                const lotIndex =
                    this.activeLotImagesLotIndex !== null &&
                    this.activeLotImagesLotIndex !== undefined
                        ? this.activeLotImagesLotIndex
                        : this.getLotIndex(lot);
                if (lotIndex !== -1 && this.inspection.inspection_lots[lotIndex]) {
                    this.inspection.inspection_lots[lotIndex].inspection_lot_attachments = [
                        ...(lot.inspection_lot_attachments || []),
                    ];
                }
            },

            saveLotImagesModal() {
                const lot = this.activeLotImagesLot;
                if (!lot || !this.hasUnsavedLotAttachments(lot)) {
                    return;
                }

                if (!this.inspection.inspection_id || !lot.inspection_lot_id) {
                    this.$store.dispatch(
                        "success",
                        "Images will be uploaded when you submit or update the inspection."
                    );
                    this.hideLotImagesModal();
                    return;
                }

                const loader = this.$loading.show();
                this.uploadLotPendingAttachments(lot)
                    .then(() => {
                        loader.hide();
                        this.lotImagesModalList = this.buildLotImagesModalList(lot);
                        this.syncLotAttachmentsToInspection(lot);
                        this.$store.dispatch("success", "Images uploaded successfully");
                    })
                    .catch((error) => {
                        loader.hide();
                        this.$store.dispatch(
                            "error",
                            error.response?.data?.message || "Failed to upload images"
                        );
                    });
            },

            uploadLotPendingAttachments(lot) {
                const unsaved = this.getUnsavedLotAttachments(lot);
                if (!unsaved.length || !lot.inspection_lot_id || !this.inspection.inspection_id) {
                    return Promise.resolve();
                }

                return this.$store
                    .dispatch("post", {
                        uri: "storeInspectionLotAttachments",
                        data: {
                            inspection_id: this.inspection.inspection_id,
                            inspection_lot_id: lot.inspection_lot_id,
                            attachments: unsaved.map((p) => ({
                                attachment: p.attachment,
                                type: p.type,
                            })),
                        },
                    })
                    .then((response) => {
                        const uploaded = response.data?.data || [];
                        const uploadedList = Array.isArray(uploaded) ? uploaded : [];
                        const saved = (lot.inspection_lot_attachments || []).filter(
                            (a) => a.inspection_lot_attachment_id
                        );
                        lot.inspection_lot_attachments = [...saved, ...uploadedList];
                    });
            },

            uploadAllPendingLotAttachments() {
                const lots = (this.inspection.inspection_lots || []).filter(
                    (lot) =>
                        lot.inspection_lot_id && this.hasUnsavedLotAttachments(lot)
                );
                if (!lots.length || !this.inspection.inspection_id) {
                    return Promise.resolve();
                }
                return Promise.all(lots.map((lot) => this.uploadLotPendingAttachments(lot)));
            },
        },
    };
</script>

<style scoped>
    .icon_hgt_25 {
        font-size: 25px !important;
    }

    .card-one {
        height: auto !important;
    }
</style>
